import { ThirdPartyOrder, ThirdPartyPlatform, XiaodengtaOrderRaw, YunjiOrderRaw } from 'src/types/order';

interface ThirdPartyOrderInfo {
  receiverName: string;
  receiverMobile: string;
  payId?: string;
  totalPrice: number;
  buyerComment?: string;
  tradeName?: string;
  qty: number;
  province?: string;
  city?: string;
  address: string;
}

class OrderManager {
  getThirdPartyOrderInfo(order: ThirdPartyOrder): ThirdPartyOrderInfo | undefined {
    switch (order.platform) {
      case ThirdPartyPlatform.YUNJI: {
        const {
          receiverName,
          receiverMobile,
          receiverProvince,
          receiverCity,
          receiverAddress,
          payId,
          receiverArea,
          orderDetail: orderDetails,
          totalPrice,
          buyerComment,
        } = order.raw as YunjiOrderRaw;

        const [orderDetail] = orderDetails;
        return {
          receiverName,
          receiverMobile,
          payId,
          totalPrice,
          buyerComment: buyerComment || '',
          tradeName: orderDetail.name,
          qty: orderDetail.qty,
          province: receiverProvince,
          city: receiverCity,
          address: `${receiverProvince}${receiverCity}${receiverArea}${receiverAddress}`,
        };
      }
      case ThirdPartyPlatform.XIAODENGTA: {
        const { address, contactName, contactPhone, orderPrice } = order.raw as XiaodengtaOrderRaw;
        return {
          address,
          receiverName: contactName,
          receiverMobile: contactPhone,
          totalPrice: orderPrice / 100,
          qty: 1,
        };
      }
    }
    return;
  }
}

const orderManager = new OrderManager();
export { orderManager };



// WEBPACK FOOTER //
// ./src/services/order.ts